import { Button } from '@/components/ui/Button'
import { cn } from '@/lib/cn'
import { typoNode } from '@/lib/typo'

/**
 * A screen without data is an invitation to act (design §6.9): a `title-2` heading, an
 * explanation in `text-2` and one button. `children` sits between them (e.g. «Совпадения есть
 * в: …» as buttons). No illustration, no «Здесь пока пусто».
 *
 * Three flavours (WP-05), the wording is the caller's:
 * - filtered: «Ничего не найдено» + «Сбросить фильтры»;
 * - true-empty: the creating action («Новая рассылка», «Добавить оператора»);
 * - queue-empty: «Новых заявок нет» + a way to the next tab («Открыть „На проверке“»).
 */
export function EmptyState({
  title,
  text,
  action,
  children,
  as: Tag = 'h3',
  className,
}: {
  title: string
  text?: React.ReactNode
  action?: { label: string; onClick: () => void; variant?: 'primary' | 'secondary' }
  children?: React.ReactNode
  as?: 'h2' | 'h3'
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-center gap-3 px-4 py-10 text-center', className)}>
      <Tag className="text-title-2 font-semibold text-ink-1 [overflow-wrap:anywhere]">{typoNode(title)}</Tag>
      {text && <p className="max-w-prose text-body text-ink-2">{typoNode(text)}</p>}
      {children}
      {action && (
        <Button variant={action.variant ?? 'secondary'} onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  )
}
